export default function loadLocale(locale) {
  return new Promise((resolve) => {
    switch (locale) {
    case 'en':
  
      case 'en-US': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./en-US'], (require) => {
          const data = require('./en-US');
          resolve(data.__esModule === true ? data.default : data);
          }, 'en-US');
        } else {
          const data = require('./en-US');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'en-GB': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./en-GB'], (require) => {
          const data = require('./en-GB');
          resolve(data.__esModule === true ? data.default : data);
          }, 'en-GB');
        } else {
          const data = require('./en-GB');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'en-AU': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./en-AU'], (require) => {
          const data = require('./en-AU');
          resolve(data.__esModule === true ? data.default : data);
          }, 'en-AU');
        } else {
          const data = require('./en-AU');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'fr':
  
      case 'fr-FR': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./fr-FR'], (require) => {
          const data = require('./fr-FR');
          resolve(data.__esModule === true ? data.default : data);
          }, 'fr-FR');
        } else {
          const data = require('./fr-FR');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'fr-CA': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./fr-CA'], (require) => {
          const data = require('./fr-CA');
          resolve(data.__esModule === true ? data.default : data);
          }, 'fr-CA');
        } else {
          const data = require('./fr-CA');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'de':
  
      case 'de-DE': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./de-DE'], (require) => {
          const data = require('./de-DE');
          resolve(data.__esModule === true ? data.default : data);
          }, 'de-DE');
        } else {
          const data = require('./de-DE');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'it':
  
      case 'it-IT': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./it-IT'], (require) => {
          const data = require('./it-IT');
          resolve(data.__esModule === true ? data.default : data);
          }, 'it-IT');
        } else {
          const data = require('./it-IT');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'es':
  
      case 'es-ES': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./es-ES'], (require) => {
          const data = require('./es-ES');
          resolve(data.__esModule === true ? data.default : data);
          }, 'es-ES');
        } else {
          const data = require('./es-ES');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'es-419': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./es-419'], (require) => {
          const data = require('./es-419');
          resolve(data.__esModule === true ? data.default : data);
          }, 'es-419');
        } else {
          const data = require('./es-419');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'ja':
  
      case 'ja-JP': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./ja-JP'], (require) => {
          const data = require('./ja-JP');
          resolve(data.__esModule === true ? data.default : data);
          }, 'ja-JP');
        } else {
          const data = require('./ja-JP');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'pt':
  
      case 'pt-PT': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./pt-PT'], (require) => {
          const data = require('./pt-PT');
          resolve(data.__esModule === true ? data.default : data);
          }, 'pt-PT');
        } else {
          const data = require('./pt-PT');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'pt-BR': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./pt-BR'], (require) => {
          const data = require('./pt-BR');
          resolve(data.__esModule === true ? data.default : data);
          }, 'pt-BR');
        } else {
          const data = require('./pt-BR');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'zh':
  
      case 'zh-CN': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./zh-CN'], (require) => {
          const data = require('./zh-CN');
          resolve(data.__esModule === true ? data.default : data);
          }, 'zh-CN');
        } else {
          const data = require('./zh-CN');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'zh-TW': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./zh-TW'], (require) => {
          const data = require('./zh-TW');
          resolve(data.__esModule === true ? data.default : data);
          }, 'zh-TW');
        } else {
          const data = require('./zh-TW');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      case 'zh-HK': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./zh-HK'], (require) => {
          const data = require('./zh-HK');
          resolve(data.__esModule === true ? data.default : data);
          }, 'zh-HK');
        } else {
          const data = require('./zh-HK');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'nl':
  
      case 'nl-NL': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./nl-NL'], (require) => {
          const data = require('./nl-NL');
          resolve(data.__esModule === true ? data.default : data);
          }, 'nl-NL');
        } else {
          const data = require('./nl-NL');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
    case 'ko':
  
      case 'ko-KR': {
        if (typeof require.ensure === 'function') {
          require.ensure(['./ko-KR'], (require) => {
          const data = require('./ko-KR');
          resolve(data.__esModule === true ? data.default : data);
          }, 'ko-KR');
        } else {
          const data = require('./ko-KR');
          resolve(data.__esModule === true ? data.default : data);
        }
        break;
      }
      default:
        resolve({});
        break;
    }
  });
}
